export const encodeBase64 = (value: string): string => {
	const bytes = new TextEncoder().encode(value);
	let binary = '';

	bytes.forEach(byte => {
		binary += String.fromCharCode(byte);
	});

	return btoa(binary);
};

export const decodeBase64ToUint8Array = (value: string): Uint8Array => {
	const binary = atob(value);
	const bytes = new Uint8Array(binary.length);

	for (let index = 0; index < binary.length; index += 1) {
		bytes[index] = binary.charCodeAt(index);
	}

	return bytes;
};
